import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Spark',
		img: imgPath + 'Spark.jpg',
		href: 'https://spark.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Gimp',
		img: imgPath + 'Gimp.jpg',
		href: 'https://gimp.shopiko.bg'
	},
	{
		name: 'Fashion Weeks',
		img: imgPath + 'FashionWeeks.jpg',
		href: 'https://fashionweeks.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Spark',
		img: imgPath + 'Spark.jpg',
		href: 'https://spark.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Gimp',
		img: imgPath + 'Gimp.jpg',
		href: 'https://gimp.shopiko.bg'
	},
	{
		name: 'Fashion Weeks',
		img: imgPath + 'FashionWeeks.jpg',
		href: 'https://fashionweeks.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];